import { render, staticRenderFns } from "./Portefeuille.vue?vue&type=template&id=6288c5ba&scoped=true"
import script from "./Portefeuille.vue?vue&type=script&lang=js"
export * from "./Portefeuille.vue?vue&type=script&lang=js"
import style0 from "./Portefeuille.vue?vue&type=style&index=0&id=6288c5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288c5ba",
  null
  
)

export default component.exports